// //CloudFare Link
// export const IMAGES = {
//   LOGO: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/GetgeekLogo.webp",
//   SLACK_DEFAULT:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/image90-ezgif.com-png-to-webp-converter.webp",
//   SLACK_HOVER:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/image91-ezgif.com-png-to-webp-converter.webp",
//   BG_MAIN: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/BgNewMain.webp",
//   HERO_SECTION:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/BgHeroSectionNew.webp",
//   COMPANY_1: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/C1.webp",
//   COMPANY_2: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/C2.webp",
//   COMPANY_3: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/C3.webp",
//   COMPANY_4: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/C4.webp",
//   COMPANY_5: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/C5.webp",
//   COMPANY_6: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/C6.webp",
//   COMPANY_7: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/C7.webp",
//   RATING_STARS:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/image%20(84).webp",
//   HADEESA_AVATAR:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Hadeesa.webp",
//   IQRA_AVATAR:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/IqraFatima.webp",
//   SAJID_VIDEO:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/sajid-testimonial.mp4",
//   MOAZZAM_VIDEO:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/moazzam-testimonial.mp4",
//   HIRING_BROKEN_VIDEO:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Animation%20(3).mp4",
//   HIRING_SOLUTION_VIDEO:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Circles%2BHop%2BIn%2BAnimation.mp4",
//   BEFORE_AFTER_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/beforeAfterBg.webp",
//   BEFORE_IMAGE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/uw6y70uyu8wsscv0d83n.webp",
//   AFTER_IMAGE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/image%20(82).webp",
//   WARNING_ICON:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Warnning.webp",
//   EMAIL_LOGO:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/EmaillogoImg.webp",
//   GMAIL_LOGO:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/GmaillogoImg.webp",
//   SOCIAL_PROOF_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SocialProofbg.webp",
//   RAMEEZ_KHAN:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/RameezKhanImg.webp",
//   HUMNA_AVATAR:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Humna.webp",
//   SAJID_AVATAR:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Sajid.webp",
//   MAHA_AVATAR: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Maha.webp",
//   TOOLKIT_ICON:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Toolkit.webp",
//   TOOLKIT_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ToolKitRightSideBG.webp",
//   TOOLKIT_ICON_1:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Group%201321315729.png",
//   TOOLKIT_ICON_2:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ToolkitImgTwo.webp",
//   TOOLKIT_ICON_3:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ToolkitImgThree.webp",
//   TOOLKIT_ICON_4:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ToolkitImgFour.webp",
//   TOOLKIT_ICON_5:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ToolkitImgFive.webp",
//   TOOLKIT_ICON_6:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ToolkitImgSix.webp",
//   TOOLKIT_IMG_1:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AIToolKitOne.webp",
//   TOOLKIT_IMG_2:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AIToolKitTwo.webp",
//   TOOLKIT_IMG_3:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AIToolKitThree.webp",
//   TOOLKIT_IMG_4:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AIToolKitFour.webp",
//   TOOLKIT_IMG_5:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AIToolKitFive.webp",
//   TOOLKIT_IMG_6:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AIToolKitSix.webp",
//   FEATURES_GRID_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FeaturesGridBG.webp",
//   FEATURE_ICON_1:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(1).svg",
//   FEATURE_ICON_2:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(2).svg",
//   FEATURE_ICON_3:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(3).svg",
//   FEATURE_ICON_4:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(4).svg",
//   FEATURE_ICON_5:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(5).svg",
//   FEATURE_ICON_6:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(6).svg",
//   FEATURE_ICON_7:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(7).svg",
//   FEATURE_ICON_8:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(8).svg",
//   FEATURE_ICON_9:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(9).svg",
//   FEATURE_ICON_10:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(10).svg",
//   FEATURE_ICON_11:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(11).svg",
//   FEATURE_ICON_12:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(12).svg",
//   FEATURE_ICON_13:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(13).svg",
//   FEATURE_ICON_14:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(14).svg",
//   FEATURE_ICON_15:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(15).svg",
//   FEATURE_ICON_16:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(16).svg",
//   FEATURE_ICON_17:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(17).svg",
//   FEATURE_ICON_18:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(18).svg",
//   FEATURE_ICON_20:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(20).svg",
//   FEATURE_ICON_21:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(21).svg",
//   FEATURE_ICON_22:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(22).svg",
//   FEATURE_ICON_23:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(23).svg",
//   FEATURE_ICON_24:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(24).svg",
//   FEATURE_ICON_25:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SVG%20(25).svg",
//   EVALUATION_ENGINE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/EvaluationEngine.webp",
//   AI_RECRUITER_FEATURE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/image%20(75).webp",
//   EVALUATE_TALENT_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/image%202161%20(1).webp",
//   COMPARISON_CHART_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ComparisonChartBg.webp",
//   FEATURE_COMPARISON_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FeatureComparisonBg.webp",
//   TICK_ICON: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/TickImg.webp",
//   CROSS_ICON:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/CrossImg.webp",
//   KHABIB_AVATAR:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/KhabibNurmagomedov.webp",
//   GETGEEK_LOGO_WHITE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/getgeeklogowhite.webp",
//   NUMBER_SEVEN:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Seven.webp",
//   NUMBER_NINE_FIVE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Ninepointfive.webp",
//   NUMBER_FORTY_SEVEN:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/fourtySeven.webp",
//   NUMBER_FIVE: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Five.webp",
//   STEP_1_IMAGE: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Call.webp",
//   STEP_2_IMAGE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Availiblity.webp",
//   STEP_3_IMAGE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/onboarding.webp",
//   RISK_FREE_GUARANTEE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/RiskFree.webp",
//   QUALIFIED_CANDIDATES_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/QualifiedCandidatesBg.webp",
//   INVERTED_COMMAS:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/InvertedCommas.webp",
//   RAMIZ_AVATAR:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Ramiz.webp",
//   MOAZZAM_AVATAR:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Moazzam.webp",
//   SLACK_COMMUNITY_ICON:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/image%20(92).webp",
//   GRAY_LOGO_1:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/GrayOne.webp",
//   GRAY_LOGO_2:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/GrayTwo.webp",
//   GRAY_LOGO_3:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/image%20(78).webp",
//   GRAY_LOGO_4:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/GrayFour.webp",
//   GRAY_LOGO_5:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/GrayFive.webp",
//   GRAY_LOGO_6:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/GraySix.webp",
//   GRAY_LOGO_7: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/LGSix.webp",
//   SAJID_TESTIMONIAL_AVATAR:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/image%20(88).webp",
//   TOP_QUOTE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/TopQuote.webp",
//   BOTTOM_QUOTE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/BottomQuote.webp",
//   AI_RECRUITER_LANDING_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AIRecruiterLandingBottomBG.webp",
//   RECRUITMENT_ISSUES_LEFT_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/RecruitmentIssuesLeftSideImg.webp",
//   PROBLEM_ICON:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ProblemIcon.webp",
//   WAVE_ANIMATION_LOGO:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/WaveAnimationLogo.webp",
//   COMPARISON_SECTION_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ComparisonSectionBg.webp",
//   WRONG_ICON: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Wrong.webp",
//   CORRECT_ICON:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Correct.webp",
//   FOUR_STEP_1_IMAGE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/HFourOne.webp",
//   FOUR_STEP_2_IMAGE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/HFourTwo.webp",
//   FOUR_STEP_3_IMAGE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/HFourThree.webp",
//   FOUR_STEP_4_IMAGE:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/HFourFour.webp",
//   ZAYN_ICON_1:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ZaynImgOne.webp",
//   ZAYN_ICON_2:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ZaynImgTwo.webp",
//   ZAYN_ICON_3:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ZaynImgThree.webp",
//   ZAYN_ICON_4:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ZaynImgFour.webp",
//   ZAYN_ICON_5:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ZaynImgFive.webp",
//   ZAYN_ICON_6:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ZaynImgSix.webp",
//   ZAYN_IMG_1:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AI%20Recruiting%20SoftwareOne.webp",
//   ZAYN_IMG_2:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ZaynImgTwo%20(1).webp",
//   ZAYN_IMG_3:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AI%20Recruiting%20SoftwareThree.webp",
//   ZAYN_IMG_4:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AI%20Recruiting%20SoftwareFour.webp",
//   ZAYN_IMG_5:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AI%20Recruiting%20SoftwareFive.webp",
//   ZAYN_IMG_6:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/AI%20Recruiting%20SoftwareSix.webp",
//   FLAG_1: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FlagOne.webp",
//   FLAG_2: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FlagTwo.webp",
//   FLAG_3: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FlagThree.webp",
//   FLAG_ARABIC:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FlagArabic.webp",
//   FLAG_4: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FlagFour.webp",
//   FLAG_5: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FlagFive.webp",
//   FLAG_6: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FlagSix.webp",
//   FLAG_8: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FlagEight.webp",
//   FLAG_9: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FlagNine.webp",
//   FLAG_10: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FlagTen.webp",
//   FLAG_11:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/FlagEleven.webp",

//   LANGUAGES_RIGHT_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/LanguagesRightSideImg.webp",
//   TESTIMONIAL_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/TestimonialBGImg.webp",
//   ONFOLK_TESTIMONIAL_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/rectangle_5964_1x.webp",
//   CANDIDATE_1:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignermanOne.webp",
//   CANDIDATE_2:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignermanTwo.webp",
//   CANDIDATE_3:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignerThree.webp",
//   CANDIDATE_4:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignerFour.webp",
//   CANDIDATE_5:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignerFive.webp",
//   CANDIDATE_6:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignerSix.webp",
//   CANDIDATE_7:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignerSeven.webp",
//   CANDIDATE_8:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignerEight.webp",
//   CANDIDATE_9:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignerNine.webp",
//   CANDIDATE_10:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignerTen.webp",
//   CANDIDATE_11:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignereleven.webp",
//   CANDIDATE_12:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/foreignerTweleve.webp",
//   CANDIDATE_13:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ImgThirteen.webp",
//   CANDIDATE_14:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/image%20(76).webp",
//   CORRECT_IMG_NEW:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/CorrectImgNew.webp",
//   ICON_1: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/IconOne.webp",
//   ICON_2: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/IconTwo.webp",
//   ICON_3: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/IconThree.webp",
//   ICON_4: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/IconFour.webp",
//   ICON_5: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/IconFive.webp",
//   BG_WE_DELIVER:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/BgOfWedeliver.webp",
//   GRADIENT_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Gradient.webp",
//   HS_ONE: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/HSOne.webp",
//   HS_TWO: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/HSTwo.webp",
//   HS_THREE: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/HSThree.webp",
//   SECURITY_IMG_1:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SecurityFeaturesImgOne.webp",
//   SECURITY_IMG_2:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SecurityFeaturesImgTwo.webp",
//   SECURITY_IMG_3:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SecurityFeaturesImgThree.webp",
//   SECURITY_IMG_4:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SecurityFeaturesImgFour.webp",
//   SECURITY_IMG_5:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SecurityFeaturesImgFive.webp",
//   SECURITY_IMG_6:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SecurityFeaturesImgSix.webp",
//   INTEGRATION_45_PLUS:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/45PlusIntegrationImg%20(1).webp",
//   MOBILE_BG_INTEGRATION:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/MobileBgCompanyIntegration.webp",
//   COMPANY_IMG_1:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ComapnyImageOne.webp",
//   COMPANY_IMG_2:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ComapnyImageTwo.webp",
//   COMPANY_IMG_3:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ComapnyImageThree.webp",
//   EYES_GIF: "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/Eyes.gif",
//   LEARN_CODING_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/learnCoding.webp",
//   MAIN_ARTICLE_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/MainArtcle.webp",
//   ARTICLE_1_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ArticleOne.webp",
//   ARTICLE_2_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ArtcleTwoImg.webp",
//   ARTICLE_3_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ArtcleThreeImg.webp",
//   ARTICLE_4_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ArtcleFourImg.webp",
//   ARTICLE_5_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ArtcleFiveImg.webp",
//   SUBSCRIBE_BLOG_IMG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/SubscribeBlogImg.webp",
//   CONTACT_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/ContactpageBgNew.webp",
//   CONTACT_FORM_BG:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/image%20(77).webp",
//   TAILORED_DEMO_ICON:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/TailoredDemo.webp",
//   START_FREE_TRIAL_ICON:
//     "https://pub-b4a0d7160e804448b1c1062c499df6e5.r2.dev/StartFreeTrial.webp",
// };

//BunnyCDN Link
export const IMAGES = {
  LOGO: "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/getgeek_new_logo_2x.webp",
  LOGOONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/GetgeekLogoWhiteOne.webp",

  SLACK_DEFAULT:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image90-ezgif.com-png-to-webp-converter.webp",
  SLACK_HOVER:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image91-ezgif.com-png-to-webp-converter.webp",
  BG_MAIN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/BgNewMain.webp",
  HERO_SECTION:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(36).webp",
  // "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Getgeek%20-%20Homepage%20-%20Video.mp4",
  COMPANY_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/C1.webp",
  COMPANY_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/C2.webp",
  COMPANY_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/C3.webp",
  COMPANY_4:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/C4.webp",
  COMPANY_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/C5.webp",
  COMPANY_6:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/C6.webp",
  COMPANY_7:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/C7.webp",
  RATING_STARS:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(84).webp",
  HADEESA_AVATAR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Hadeesa.webp",
  IQRA_AVATAR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/IqraFatima.webp",
  SAJID_VIDEO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Sajid%20Video_1.mp4",
  MOAZZAM_VIDEO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Moazzam%20Video_1.mp4",
  HIRING_BROKEN_VIDEO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Animation%20(3).mp4",
  HIRING_SOLUTION_VIDEO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/We%20Fix%20It%20-%20Animation.mp4",
  BEFORE_AFTER_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/beforeAfterBg.webp",
  BEFORE_IMAGE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/uw6y70uyu8wsscv0d83n.webp",
  AFTER_IMAGE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/After.webp",
  WARNING_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Warnning.webp",
  EMAIL_LOGO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/EmaillogoImg.webp",
  GMAIL_LOGO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/GmaillogoImg.webp",
  SOCIAL_PROOF_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SocialProofbg.webp",
  RAMEEZ_KHAN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/RameezKhanImg.webp",
  HUMNA_AVATAR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Humna.webp",
  SAJID_AVATAR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Sajid.webp",
  MAHA_AVATAR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Maha.webp",
  TOOLKIT_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Toolkit.webp",
  TOOLKIT_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolKitRightSideBG.webp",
  TOOLKIT_ICON_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Group%201321315729.png",
  TOOLKIT_ICON_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolkitImgTwo.webp",
  TOOLKIT_ICON_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolkitImgThree.webp",
  TOOLKIT_ICON_4:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolkitImgFour.webp",
  TOOLKIT_ICON_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolkitImgFive.webp",
  TOOLKIT_ICON_6:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolkitImgSix.webp",
  TOOLKIT_IMG_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AIToolKitOne.webp",
  TOOLKIT_IMG_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AIToolKitTwo.webp",
  TOOLKIT_IMG_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TOOLKIT_IMG_3.webp",
  TOOLKIT_IMG_4:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AIToolKitFour.webp",
  TOOLKIT_IMG_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AIToolKitFive.webp",
  TOOLKIT_IMG_6:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TOOLKIT_IMG_6.webp",
  FEATURES_GRID_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FeaturesGridBG.webp",
  FEATURE_ICON_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(1).svg",
  FEATURE_ICON_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(2).svg",
  FEATURE_ICON_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(3).svg",
  FEATURE_ICON_4:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(4).svg",
  FEATURE_ICON_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(5).svg",
  FEATURE_ICON_6:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(6).svg",
  FEATURE_ICON_7:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(7).svg",
  FEATURE_ICON_8:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(8).svg",
  FEATURE_ICON_9:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(9).svg",
  FEATURE_ICON_10:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(10).svg",
  FEATURE_ICON_11:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(11).svg",
  FEATURE_ICON_12:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(12).svg",
  FEATURE_ICON_13:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(13).svg",
  FEATURE_ICON_14:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(14).svg",
  FEATURE_ICON_15:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(15).svg",
  FEATURE_ICON_16:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(16).svg",
  FEATURE_ICON_17:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(17).svg",
  FEATURE_ICON_18:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(18).svg",
  FEATURE_ICON_20:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(20).svg",
  FEATURE_ICON_21:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(21).svg",
  FEATURE_ICON_22:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(22).svg",
  FEATURE_ICON_23:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(23).svg",
  FEATURE_ICON_24:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(24).svg",
  FEATURE_ICON_25:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SVG%20(25).svg",
  EVALUATION_ENGINE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/EvaluationEngine.webp",
  AI_RECRUITER_FEATURE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(75).webp",
  ZAYN_BG_IMAGE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Zayn%20BG%20image.webp",
  ZAYN_ORB_VIDEO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/NEW%20ICONIC%20Orb%20for%20Getgeek-With%20shape-FIXED-1080x1080-7bit.mp4",
  EVALUATE_TALENT_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image-evaluate.webp",
  COMPARISON_CHART_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ComparisonChartBg.webp",
  FEATURE_COMPARISON_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FeatureComparisonBg.webp",
  TICK_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TickImg.webp",
  CROSS_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CrossImg.webp",
  KHABIB_AVATAR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/KhabibNurmagomedov.webp",
  GETGEEK_LOGO_WHITE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/GETGEEK_LOGO_WHITE.webp",
  NUMBER_SEVEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Seven.webp",
  NUMBER_NINE_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Ninepointfive.webp",
  NUMBER_FORTY_SEVEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/fourtySeven.webp",
  NUMBER_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Five.webp",
  STEP_1_IMAGE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Call.webp",
  STEP_2_IMAGE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Availiblity.webp",
  STEP_3_IMAGE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/STEP_3_IMAGE.webp",
  RISK_FREE_GUARANTEE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/RiskFree.webp",
  QUALIFIED_CANDIDATES_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/QualifiedCandidatesBg.webp",
  INVERTED_COMMAS:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/InvertedCommas.webp",
  RAMIZ_AVATAR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Ramiz.webp",
  MOAZZAM_AVATAR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Moazzam.webp",
  SLACK_COMMUNITY_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(92).webp",
  ZAYN_LANDING_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/zayn_landing_page_1x.webp",
  ZAYN_LOOP_VIDEO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Zayn%20video%20Thumbnail.mp4",
  ZAYN_FULL_VIDEO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/New-Zayn-%20Video.mp4",
  GRAY_LOGO_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/GrayOne.webp",
  GRAY_LOGO_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/GrayTwo.webp",
  GRAY_LOGO_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(14).webp",
  GRAY_LOGO_4:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/GrayFour.webp",
  GRAY_LOGO_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/GrayFive.webp",
  GRAY_LOGO_6:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/GraySix.webp",
  GRAY_LOGO_7:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/LGSix.webp",
  SAJID_TESTIMONIAL_AVATAR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TestimonailSajidonZaynPageImgNew.webp",
  TOP_QUOTE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TopQuote.webp",
  BOTTOM_QUOTE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/BottomQuote.webp",
  AI_RECRUITER_LANDING_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AIRecruiterLandingBottomBG.webp",
  RECRUITMENT_ISSUES_LEFT_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/RecruitmentIssuesLeftSideImg.webp",
  PROBLEM_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ProblemIcon.webp",
  WAVE_ANIMATION_LOGO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/WAVE_ANIMATION_LOGO.webp",
  COMPARISON_SECTION_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ComparisonSectionBg.webp",
  WRONG_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Wrong.webp",
  CORRECT_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Correct.webp",
  FOUR_STEP_1_IMAGE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/HFourOne.webp",
  FOUR_STEP_2_IMAGE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/HFourTwo.webp",
  FOUR_STEP_3_IMAGE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/HFourThree.webp",
  FOUR_STEP_4_IMAGE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FOUR_STEP_4_IMAGE.webp",
  ZAYN_ICON_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ZaynImgOne.webp",
  ZAYN_ICON_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ZaynImgTwo.webp",
  ZAYN_ICON_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ZaynImgThree.webp",
  ZAYN_ICON_4:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ZaynImgFour.webp",
  ZAYN_ICON_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ZaynImgFive.webp",
  ZAYN_ICON_6:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ZaynImgSix.webp",
  ZAYN_IMG_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AI%20Recruiting%20SoftwareOne.webp",
  ZAYN_IMG_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ZaynImgTwo%20(1).webp",
  ZAYN_IMG_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AI%20Recruiting%20SoftwareThree.webp",
  ZAYN_IMG_4:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AI%20Recruiting%20SoftwareFour.webp",
  ZAYN_IMG_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AI%20Recruiting%20SoftwareFive.webp",
  ZAYN_IMG_6:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AI%20Recruiting%20SoftwareSix.webp",
  FLAG_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagOne.webp",
  FLAG_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagTwo.webp",
  FLAG_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagThree.webp",
  FLAG_ARABIC:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagArabic.webp",
  FLAG_4:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagFour.webp",
  FLAG_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagFive.webp",
  FLAG_6:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagSix.webp",
  FLAG_8:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagEight.webp",
  FLAG_9:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagNine.webp",
  FLAG_10:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagTen.webp",
  FLAG_11:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagEleven.webp",

  LANGUAGES_RIGHT_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/LANGUAGES_RIGHT_IMG.webp",
  TESTIMONIAL_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TestimonialBGImg.webp",
  ONFOLK_TESTIMONIAL_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(13).webp",
  CANDIDATE_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignermanOne.webp",
  CANDIDATE_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignermanTwo.webp",
  CANDIDATE_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignerThree.webp",
  CANDIDATE_4:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignerFour.webp",
  CANDIDATE_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignerFive.webp",
  CANDIDATE_6:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignerSix.webp",
  CANDIDATE_7:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignerSeven.webp",
  CANDIDATE_8:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignerEight.webp",
  CANDIDATE_9:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignerNine.webp",
  CANDIDATE_10:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignerTen.webp",
  CANDIDATE_11:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignereleven.webp",
  CANDIDATE_12:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/foreignerTweleve.webp",
  CANDIDATE_13:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ImgThirteen.webp",
  CANDIDATE_14:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(76).webp",
  CORRECT_IMG_NEW:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CorrectImgNew.webp",
  ICON_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/IconOne.webp",
  ICON_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/IconTwo.webp",
  ICON_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/IconThree.webp",
  ICON_4:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/IconFour.webp",
  ICON_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/IconFive.webp",
  BG_WE_DELIVER:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/BgOfWedeliver.webp",
  GRADIENT_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Gradient.webp",
  HS_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/HSOne.webp",
  HS_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/HSTwo.webp",
  HS_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/HSThree.webp",
  SECURITY_IMG_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SecurityFeaturesImgOne.webp",
  SECURITY_IMG_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SecurityFeaturesImgTwo.webp",
  SECURITY_IMG_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SecurityFeaturesImgThree.webp",
  SECURITY_IMG_4:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SecurityFeaturesImgFour.webp",
  SECURITY_IMG_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SecurityFeaturesImgFive.webp",
  SECURITY_IMG_6:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SecurityFeaturesImgSix.webp",
  INTEGRATION_45_PLUS:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/45PlusIntegrationImg%20(1).webp",
  MOBILE_BG_INTEGRATION:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/MobileBgCompanyIntegration.webp",
  COMPANY_IMG_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ComapnyImageOne.webp",
  COMPANY_IMG_2:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ComapnyImageTwo.webp",
  COMPANY_IMG_3:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ComapnyImageThree.webp",
  EYES_GIF:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Eyes.gif",
  LEARN_CODING_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/learnCoding.webp",
  MAIN_ARTICLE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Article%20image.webp",
  ARTICLE_1_IMG:
    "https://getgeek-website-assets.b-cdn.net/HeroSectionRightSideImgOneBlog.webp",
  ARTICLE_2_IMG:
    "https://getgeek-website-assets.b-cdn.net/HiringProcessStepRightSideImg.webp",
  ARTICLE_3_IMG:
    "https://getgeek-website-assets.b-cdn.net/CostPerHireRightImg.webp",
  ARTICLE_4_IMG:
    "https://getgeek-website-assets.b-cdn.net/recruitmentfunnelRightSideimg.webp",
  ARTICLE_5_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ArtcleFiveImg.webp",
  SUBSCRIBE_BLOG_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SubscribeBlogImg.webp",
  CONTACT_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ContactpageBgNew.webp",
  CONTACT_FORM_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Group%201321315892%20(1).webp",
  TAILORED_DEMO_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TailoredDemo.webp",
  START_FREE_TRIAL_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/StartFreeTrial.webp",
  WEBSITE_LOADER:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/WebsiteLoaderNew.mp4",
  PRICING_TICK_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TickIcon.webp",
  PURPLE_TICK_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/vector.webp",
  TRUSTED_IMG_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TrustedImgOne.webp",

  TRUSTED_IMG_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TrustedImgTwo.webp",

  TRUSTED_IMG_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TrustedImgThree.webp",

  TRUSTED_IMG_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TrustedImgFour.webp",

  TRUSTED_IMG_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TrustedImgFive.webp",
  COMPANIES:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/group_1321316867.webp",
  IQRA_BIG_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/IqraBigImg.webp",
  TEZERACT_LOGO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/tezeract_logo_black.webp",
  SLIDER_TICK:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/sliderTick.webp",
  STATUS_CARD_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/StatsCardOne.webp",
  STATUS_CARD_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/StatsCardTwo.webp",
  STATUS_CARD_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/StatsCardThree.webp",
  WHY_GETGEEK_IMG_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ImgWhyGetgeekOne.webp",
  WHY_GETGEEK_IMG_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ImgWhyGetgeekTwo.webp",
  WHY_GETGEEK_IMG_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ImgWhyGetgeekThree.webp",
  WHY_GETGEEK_IMG_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ImgWhyGetgeekFour.webp",
  WHY_GETGEEK_IMG_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ImgWhyGetgeekFive.webp",
  WHY_GETGEEK_IMG_SIX:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ImgWhyGetgeekSix.webp",
  OFF_IMG: "https://getgeek-website-assets.b-cdn.net/10%25OffImg.webp",
  PRICING_MAIN_BG: "https://getgeek-website-assets.b-cdn.net/PricingBG.webp",
  TRUST_MAIN_BG: "https://getgeek-website-assets.b-cdn.net/image%20(18).webp",
  FMS_ONE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FMSOne.webp",
  FMS_TWO_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FMSTwo.webp",
  FMS_THREE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FMSThree.webp",
  FMS_FOUR_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FMSFour.webp",
  FIVE_STARS_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Stars.webp",
  TSFM_ONE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TSFMOne.webp",
  TSFM_TWO_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TSFMTwo.webp",
  TSFM_THREE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TSFMThree.webp",
  TSFM_FOUR_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TSFMFour.webp",
  HN_ONE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/HN1.webp",
  HN_TWO_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/HN2.webp",
  HN_THREE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/HN3.webp",
  HN_FOUR_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/HN4.webp",
  ET_ONE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ETOne.webp",
  ET_TWO_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ETTwo.webp",
  ET_THREE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ETThree.webp",
  THREE_DOTS_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ThreeDots.webp",
  SPARK_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Spark.webp",
  BELL_ICON_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FoundingMemeberWarnningBell.webp",
  FOUNDING_MEMBER_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(19).webp",
  CHECKICON_WITH_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(20).webp",
  TOOL_IMG_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgOne.webp",
  TOOL_IMG_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgTwo.webp",
  TOOL_IMG_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgThree.webp",
  TOOL_IMG_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgFour.webp",
  TOOL_IMG_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgFive.webp",
  TOOL_IMG_SIX:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgSix.webp",
  TOOL_IMG_SEVEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgSeven.webp",
  TOOL_IMG_EIGHT:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgEight.webp",
  TOOL_IMG_NINE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgNine.webp",
  TOOL_IMG_TEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgTen.webp",
  TOOL_IMG_ELEVEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgeleven.webp",
  TOOL_IMG_TWELVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgTwelve.webp",
  TOOL_IMG_THIRTEEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgThirteen.webp",
  TOOL_IMG_FOURTEEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgFourteen.webp",
  TOOL_IMG_FIFTEEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgFifteen.webp",
  TOOL_IMG_SIXTEEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgSixteen.webp",
  TOOL_IMG_SEVENTEEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgSeventeen.webp",
  TOOL_IMG_EIGHTEEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgEigtheen.webp",
  TOOL_IMG_NINETEEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ToolImgNineteen.webp",
  PURPLE_BG_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(21).webp",
  OFFER_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/OFFER_ONE.webp",
  OFFER_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/OFFER_TWO.webp",
  OFFER_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/OfferManagementThree.webp",
  OFFER_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/OFFER-FOUR.webp",
  OFFER_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/OfferManagementFive.webp",
  OFFER_SIX:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/OFFER_SIX.webp",
  YELLOW_BG_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(22).webp",
  SCREENING_ONE:
    "https://getgeek-website-assets.b-cdn.net/AIScreening.webp",
  SCREENING_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ScreeningAndMatchingTwo.webp",
  SCREENING_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ScreeningAndMatchingThree.webp",
  SCREENING_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SCREENING_FOUR.webp",
  SCREENING_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SCREENING_FIVE.webp",
  SCREENING_SIX:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ScreeningAndMatchingSix.webp",

  ANALYTICS_AND_REPORTING_ICON:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AnalyticsAndReportingIcon.webp",
  ANALYTICS_AND_REPORTING_RIGHT_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AnalyticsAndReportingRightImg.webp",
  ANALYTICS_AND_REPORTING_ICON_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AnalyticsAndReportingIconOne.webp",
  ANALYTICS_AND_REPORTING_ICON_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AnalyticsAndReportingIconTwo.webp",
  ANALYTICS_AND_REPORTING_ICON_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AnalyticsAndReportingIconThree.webp",
  ANALYTICS_AND_REPORTING_ICON_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AnalyticsAndReportingIconFour.webp",
  ANALYTICS_AND_REPORTING_ICON_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AnalyticsAndReportingIconFive.webp",
  ANALYTICS_AND_REPORTING_ICON_SIX:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AnalyticsAndReportingIconSix.webp",
  ANALYTICS_AND_REPORTING_ICON_SEVEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AnalyticsAndReportingIconSeven.webp",

  CUSTOM_REPORTS_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CustomReportsImg.webp",
  RECRUITING_ANALYTICS_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/RecruitingAnalyticsImg.webp",
  DEI_METRICS_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/DEIMetricsImg.webp",
  PINK_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(23).webp",
  RECURITERHUB_SIDE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/RecuriterHubSideImg.webp",
  RECURITERHUB_ICON_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/RecuriterHubImg.webp",
  TCC_ICON_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCCIconOne.webp",
  TCC_ICON_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCCIconTwo.webp",
  TCC_ICON_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCCIconThree.webp",
  TCC_ICON_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCCIconFour.webp",
  TCC_ICON_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCCIconFive.webp",
  TCC_ICON_SIX:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCCIconSix.webp",

  TCC_IMG_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCC_IMG_ONE.webp",
  TCC_IMG_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCC_IMG_TWO.webp",
  // TCC_IMG_TWO:
  //   "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCCIMGThree.webp",
  TCC_IMG_THREE:
    "https://getgeek-website-assets.b-cdn.net/CentralizedDatabase.webp",
  TCC_IMG_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCC_IMG_FOUR%20(1).webp",
  TCACG_IMG_ONE: "https://getgeek-website-assets.b-cdn.net/TCACG_IMG_ONE.webp",
  TCACG_IMG_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCACG_IMG_TWO.webp",
  TCACG_IMG_THREE:
    "https://getgeek-website-assets.b-cdn.net/SmartNotification.webp",
  TCACG_IMG_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/TCACG_IMG_FOUR.webp",
  BLUE_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/image%20(24).webp",
  CUSTOM_HIRING_ICON_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CustomHiringPipelinesImg.webp",
  CUSTOM_HIRING_ICON_RIGHT_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CUSTOM_HIRING_ICON_RIGHT_IMG.webp",
  ATS_ICON_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ATSIconOne.webp",
  ATS_ICON_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ATSIconTwo.webp",
  ATS_ICON_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ATSIconThree.webp",
  ATS_ICON_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ATSIconFour.webp",
  ATS_ICON_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ATSIconFive.webp",
  ATS_ICON_SIX:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ATSIconSix.webp",
  ATS_IMG_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ATSIMGONE.webp",
  ATS_IMG_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ATSIMGTWO.webp",
  ATS_IMG_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ATSIMGTHREE.webp",
  ATS_IMG_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ATSIMGFOUR.webp",
  SEARCH_ICON_PINK:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SearchIconPink.webp",
  SOURCING_RIGHT_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/SOURCING_RIGHT_IMG.webp",
  CSS_ICON_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIconOne.webp",
  CSS_ICON_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIconTwo.webp",
  CSS_ICON_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIconThree.webp",
  CSS_ICON_FOUR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIconFour.webp",
  CSS_ICON_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIconFive.webp",
  CSS_ICON_SIX:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIconSix.webp",
  CSS_ICON_SEVEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIconSeven.webp",
  CSS_IMG_ONE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIMGOne.webp",
  CSS_IMG_TWO:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIMGTwo.webp",
  CSS_IMG_THREE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIMGThree.webp",
  // CSS_IMG_FOUR:
  //   "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIMGFour.webp",
    CSS_IMG_FOUR:
    "https://getgeek-website-assets.b-cdn.net/CareerPage.webp",
  CSS_IMG_FIVE:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSS_IMG_FIVE.webp",
  CSS_IMG_SIX:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSS_IMG_SIX.webp",
  CSS_IMG_SEVEN:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/CSSIMGSeven.webp",
  KEY_CAPABILITY_RIGHT_SIDE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/KEY_CAPABILITY_RIGHT_SIDE_IMG.webp",
  PRODUCT_HERO_SECTION:
    "https://getgeek-website-assets.b-cdn.net/image%20(26).webp",
  PRODUCT_HERO_SECTION_CENTER_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/PRODUCT_HERO_SECTION_CENTER_IMG.webp",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_ICON_1:
    "https://getgeek-website-assets.b-cdn.net/SVG%20(33).svg",

  AI_RECRUITER_AND_VIDEO_INTERVIEWS_ICON_2:
    "https://getgeek-website-assets.b-cdn.net/SVG%20(30).svg",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_ICON_3:
    "https://getgeek-website-assets.b-cdn.net/SVG%20(34).svg",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_ICON_4:
    "https://getgeek-website-assets.b-cdn.net/SVG%20(26).svg",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_ICON_5:
    "https://getgeek-website-assets.b-cdn.net/SVG%20(27).svg",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_ICON_6:
    "https://getgeek-website-assets.b-cdn.net/SVG%20(28).svg",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_ICON_7:
    "https://getgeek-website-assets.b-cdn.net/SVG%20(29).svg",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_ICON_8:
    "https://getgeek-website-assets.b-cdn.net/SVG%20(30).svg",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_ICON_9:
    "https://getgeek-website-assets.b-cdn.net/SVG%20(32).svg",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_ICON_10:
    "https://getgeek-website-assets.b-cdn.net/SVG%20(31).svg",

  AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_1:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_1%20(1).webp",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_2:
    "https://getgeek-website-assets.b-cdn.net/AIRecruiterAndVideoInterviewsImgTwo.webp",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_3:
    "https://getgeek-website-assets.b-cdn.net/AIRecruiterAndVideoInterviewsImgThree.webp",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_4:
    "https://getgeek-website-assets.b-cdn.net/AIRecruiterAndVideoInterviewsImgFour.webp",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_5:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_5.webp",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_6:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/group_1321316367I_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_6.webp",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_7:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_7.webp",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_8:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_8.webp",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_9:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/group_1321317356AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_9.webp",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_10:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_10.webp",
  AI_RECRUITER_AND_VIDEO_INTERVIEWS_IMG_11:
    "https://getgeek-website-assets.b-cdn.net/AIRecruiterAndVideoInterviewsImgTweleve.webp",
  ARABIC_BG: "https://getgeek-website-assets.b-cdn.net/ArabicBg.webp",
  RISK_FREE_ARABIC_IMG:
    "https://getgeek-website-assets.b-cdn.net/RiskFreeArabic.webp",
  EVALUATION_ENGINE_ARABIC:
    "https://getgeek-website-assets.b-cdn.net/EvaluationEngineArabic.webp",
  AI_RECRUITER_FEATURE_ARABIC:
    "https://getgeek-website-assets.b-cdn.net/AiRecruiterFeauture.webp",
  CONTACT_FORM_BG_ARABIC:
    "https://getgeek-website-assets.b-cdn.net/CONTACT_FORM_BG_ARABIC.webp",
  INTEGRATION_45_PLUS_ARABIC:
    "https://getgeek-website-assets.b-cdn.net/INTEGRATION_45_PLUS_ARABIC.webp",
  RECRUITMENT_ISSUES_LEFT_IMG_ARABIC:
    "https://getgeek-website-assets.b-cdn.net/RECRUITMENT_ISSUES_LEFT_IMG_ARABIC.webp",
  CTA_BG_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Mp4%20-%20Getgeek%20-%20CTA.mp4",
  PURPLE_QUESTION_MARK_IMG:
    "https://getgeek-website-assets.b-cdn.net/PurpleQuestionMark.webp",
  PURPLE_QUESTION_MARK_ARABIC_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ArabicQuestionMark.webp",

  PURPLE_ARROW_IMG:
    "https://getgeek-website-assets.b-cdn.net/PurpleArrowImg.webp",
  PURPLE_ARROW_ARABIC_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/ArrowArabic.webp",
    YELLOW_ARROW_IMG:"https://getgeek-website-assets.b-cdn.net/YehllowArrowCTA.webp",
        YELLOW_ARROW_ARABIC_IMG:"https://getgeek-website-assets.b-cdn.net/YellowArabicArrow.webp",

  AI_AGENT_BG:
    "https://getgeek-website-assets.b-cdn.net/AiAgentMainSectionBg.webp",
  ZAYN_CIRCLE: "https://getgeek-website-assets.b-cdn.net/ZaynCircle.webp",
  ATLAS_CIRCLE: "https://getgeek-website-assets.b-cdn.net/AtlasCircle.webp",
  SAGE_CIRCLE: "https://getgeek-website-assets.b-cdn.net/SageCircle.webp",
  SCOUT_CIRCLE: "https://getgeek-website-assets.b-cdn.net/ScoutCircle.webp",
  COMPASS_CIRCLE: "https://getgeek-website-assets.b-cdn.net/CompassCircle.webp",
  GOKU_CIRCLE: "https://getgeek-website-assets.b-cdn.net/GokuCircle.webp",
  TOP_TALENT_LINE:
    "https://getgeek-website-assets.b-cdn.net/TopTalentLine.webp",
  ONE_PLATFORM_SECTION_BG:
    "https://getgeek-website-assets.b-cdn.net/sectionOnePlatformSection.webp",
  CTA_SECTION_AI_AGENT:
    "https://getgeek-website-assets.b-cdn.net/CTASectionAIAgentBG.webp",
  SCOUT_IMG: "https://getgeek-website-assets.b-cdn.net/image%20(8).webp",
  SCOUT_IMG_LEFT: "https://getgeek-website-assets.b-cdn.net/ScoutImgLeft.webp",
  SCOUT_IMG_RIGHT:
    "https://getgeek-website-assets.b-cdn.net/ScoutImgRight.webp",
  WARNING_ICON_ALERT:
    "https://getgeek-website-assets.b-cdn.net/WaringAlert.webp",
  AWESOME_IMG: "https://getgeek-website-assets.b-cdn.net/Awesome_img.webp",
  CIRCLE_ICON_WITH_GRADIENT:
    "https://getgeek-website-assets.b-cdn.net/CircleIconWithgradient.webp",
  ZAYN_IMG: "https://getgeek-website-assets.b-cdn.net/ZaynLogo.webp",
  ZAYN_IMG_RIGHT:
    "https://getgeek-website-assets.b-cdn.net/ZAYN_IMG_RIGHT.webp",
  ZAYN_IMG_LEFT: "https://getgeek-website-assets.b-cdn.net/ZAYN_IMG_LEFT.webp",
  CIRCLE_ICON_WITHOUT_GRADIENT:
    "https://getgeek-website-assets.b-cdn.net/CircleWithoutGradient.webp",
  SAGE_IMG_RIGHT:
    "https://getgeek-website-assets.b-cdn.net/SAGE_IMG_RIGHT.webp",
  SAGE_IMG_LEFT: "https://getgeek-website-assets.b-cdn.net/SAGE_IMG_LEFT.webp",
  SAGE_IMG: "https://getgeek-website-assets.b-cdn.net/image%20(11).webp",
  ORANGE_CIRCLE: "https://getgeek-website-assets.b-cdn.net/ORANGE_CIRCLE.webp",
  ATLAS_IMG_RIGHT:
    "https://getgeek-website-assets.b-cdn.net/ATLAS_IMG_RIGHT.webp",
  ATLAS_IMG_LEFT:
    "https://getgeek-website-assets.b-cdn.net/ATLAS_IMG_LEFT.webp",
  ATLAS_IMG: "https://getgeek-website-assets.b-cdn.net/image%20(10).webp",
  BLUE_CIRCLE: "https://getgeek-website-assets.b-cdn.net/Blue_Circle.webp",
  COMPASS_IMG_RIGHt:
    "https://getgeek-website-assets.b-cdn.net/COMPASS_IMG_RIGHT.webp",
  COMPASS_IMG_LEFT:
    "https://getgeek-website-assets.b-cdn.net/COMPASS_IMG_LEFT.webp",
  COMPASS_IMG: "https://getgeek-website-assets.b-cdn.net/image%20(9).webp",
  LIGHT_ORANGE_CIRCLE:
    "https://getgeek-website-assets.b-cdn.net/LIghtOrangeCircle.webp",
  OMNI_IMG_RIGHT:
    "https://getgeek-website-assets.b-cdn.net/OMNI_IMG_RIGHT.webp",
  OMNI_IMG_LEFT: "https://getgeek-website-assets.b-cdn.net/OMNI_IMG_LEFT.webp",
  OMNI_IMG: "https://getgeek-website-assets.b-cdn.net/image%20(7).webp",
  // https://getgeek-website-assets.b-cdn.net/image%20(7).webp
  YELLOW_CIRCLE: "https://getgeek-website-assets.b-cdn.net/YellowCircle.webp",
  HERO_AI_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/BGDarkGradientBlue.webp",
  HERO_AI_RIGHT:
    "https://getgeek-website-assets.b-cdn.net/RightSideImgBlueGradient.webp",
  PURPLE_CLOCK:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/PurpleClock.webp",
  RED_CLOCK:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/RedClockImg.webp",
  ORANGE_CALENDAR:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Orangecalendar.webp",
  PINK_GROUP:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/PinkGroupImg.webp",
  PURPLE_GROUP:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/PurpleGroupImg.webp",
  NEON_IMG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/NeonImg.webp",
  RED_CROSS_ICON_WITH_BG:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/RedCroossIconwithBg.webp",
  YELLOW_LINE: "https://getgeek-website-assets.b-cdn.net/YellowLine.webp",
  ZAYN_RESULT_BG: "https://getgeek-website-assets.b-cdn.net/ZaynResultBg.webp",
  ATLAS_RESULT_BG: "https://getgeek-website-assets.b-cdn.net/AtlasBgImg.webp",
  SAGE_RESULT_BG: "https://getgeek-website-assets.b-cdn.net/SAGEresultBg.webp",
  SCOUT_RESULT_BG:
    "https://getgeek-website-assets.b-cdn.net/ScoutResultBG.webp",
  COMPASS_RESULT_BG:
    "https://getgeek-website-assets.b-cdn.net/CompassresultBg.webp",
  OMNI_RESULT_BG: "https://getgeek-website-assets.b-cdn.net/OmniResultBG.webp",
  // ICON_WITH_BG_CTA:
  //   "https://getgeek-website-assets.b-cdn.net/IconWithBGCTA.webp",
  ICON_WITH_BG_CTA:
    "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/IconWithBGCTAYellow.webp",

  // CTA_BG_ADS: "https://getgeek-website-assets.b-cdn.net/CTA_BG_ADS.webp",
  CTA_BG_ADS: "https://getgeek-website-assets.b-cdn.net/CTA_BG_ADS_Yellow.webp",

  BADGE_PURPLE_IMG:
    "https://getgeek-website-assets.b-cdn.net/Badge_purple_img.webp",
  ADS_LOGO_C1: "https://getgeek-website-assets.b-cdn.net/AdslogoOne.webp",
  ADS_LOGO_C2: "https://getgeek-website-assets.b-cdn.net/AdslogoTwo.webp",
  ADS_LOGO_C3: "https://getgeek-website-assets.b-cdn.net/AdslogoThree.webp",
  ADS_LOGO_C4: "https://getgeek-website-assets.b-cdn.net/AdslogoFour.webp",
  ADS_LOGO_C5: "https://getgeek-website-assets.b-cdn.net/AdslogoFive.webp",
  ADS_LOGO_C6: "https://getgeek-website-assets.b-cdn.net/AdslogoSix.webp",
  ADS_LOGO_C7: "https://getgeek-website-assets.b-cdn.net/AdslogoSeven.webp",
  ADS_LOGO_C8: "https://getgeek-website-assets.b-cdn.net/AdslogoEight.webp",
  ADS_LOGO_C9: "https://getgeek-website-assets.b-cdn.net/AdslogoNine.webp",
  ADS_CROSS: "https://getgeek-website-assets.b-cdn.net/Container.webp",
  ADS_TICK: "https://getgeek-website-assets.b-cdn.net/Group%201321317336.webp",
};
